import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { SAFE_ITINERARY_FALLBACK, isUsableImageUrl } from '../utils/itineraryItemImage';

const resolveSrc = (src, fallbackSrc) => {
  if (isUsableImageUrl(src)) return String(src).trim();
  if (isUsableImageUrl(fallbackSrc)) return String(fallbackSrc).trim();
  return SAFE_ITINERARY_FALLBACK;
};

const ItinerarySafeImage = ({ src, fallbackSrc, alt = '', sx }) => {
  const [currentSrc, setCurrentSrc] = useState(() => resolveSrc(src, fallbackSrc));
  const [hideImage, setHideImage] = useState(false);

  useEffect(() => {
    setCurrentSrc(resolveSrc(src, fallbackSrc));
    setHideImage(false);
  }, [src, fallbackSrc]);

  if (hideImage || !currentSrc) {
    return null;
  }

  const typeFallback = isUsableImageUrl(fallbackSrc) ? String(fallbackSrc).trim() : null;

  return (
    <Box
      component="img"
      src={currentSrc}
      alt={alt}
      data-testid="itinerary-safe-image"
      onError={() => {
        if (typeFallback && currentSrc !== typeFallback) {
          setCurrentSrc(typeFallback);
          return;
        }
        if (currentSrc !== SAFE_ITINERARY_FALLBACK) {
          setCurrentSrc(SAFE_ITINERARY_FALLBACK);
          return;
        }
        setHideImage(true);
      }}
      sx={sx}
    />
  );
};

export default ItinerarySafeImage;
